// Module
var code = `<template>
  <require from="./value-adjustment-widget.scss"></require>
  <require from="../../../converters/column-widths-converter"></require>

  <div class="value-adjustment-widget value-adjustment-widget-\${id}">
    <!-- beautify ignore:start -->
    <style if.bind="rowHeight">
      .value-adjustment-widget-\${id} tr {
        height: \${rowHeight}px !important;
      }
    </style>

    <style>
      .value-adjustment-widget-\${id} td {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .value-adjustment-widget-\${id} th {
        font-family: \${captionFont ? captionFont : 'var(--dyn-default-font-family)'};
        font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <table if.bind="!loading && !error" class="widget-table">
      <thead>
        <tr>
          <th style="\${columnWidths | columnWidths:0}">Account</th>
          <th style="\${columnWidths | columnWidths:1}">Name</th>
          <th style="\${columnWidths | columnWidths:2}">Currency</th>
          <th style="\${columnWidths | columnWidths:3}">Tax</th>
          <th style="\${columnWidths | columnWidths:4}">Lo</th>
          <th style="\${columnWidths | columnWidths:5}">LCM</th>
          <th style="\${columnWidths | columnWidths:6}">Type</th>
          <th style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">Quantity</th>
          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">Costprice (FIFO)</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">Costprice (AVG)</th>
          <th style="\${columnWidths | columnWidths:9}" class="widget-table__numeric">Estimated Value</th>
          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:10}" class="widget-table__numeric">Accounting Value (FIFO)</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:10}" class="widget-table__numeric">Accounting Value (AVG)</th>
          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:11}" class="widget-table__numeric">Unreal. Acc. Value</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:11}" class="widget-table__numeric">Unreal. Acc. Value(AVG)</th>
        </tr>
      </thead>
      <tbody>
        <template repeat.for="v of instrumentValues">
          <tr class="\${v === total ? 'widget-table__total' : ''} \${v.groupTotal ? 'widget-table__group-total' : ''}">
            <td style="\${columnWidths | columnWidths:0}">\${v.latestAccountNumber}</td>
            <td style="\${columnWidths | columnWidths:1}">\${v.reportName}<span if.bind="!v.name">&nbsp;</span></td>
            <td style="\${columnWidths | columnWidths:2}">\${v.currencyCode}</td>
            <td style="\${columnWidths | columnWidths:3}">\${v.taxable}</td>
            <td style="\${columnWidths | columnWidths:4}">\${v.longTerm}</td>
            <td style="\${columnWidths | columnWidths:5}">\${v.lowerOfCostOrMarket}</td>
            <td style="\${columnWidths | columnWidths:6}">\${v.securitiesTypeName}</td>
            <td style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">
              \${v.quantity | numericFormatter:quantityPrecision}
            </td>
            <td if.bind="displayFifo" style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">
              \${v.totalCostPrice | numericFormatter:precision}
            </td>
            <td if.bind="displayAvg" style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">
              \${v.avgCostPrice | numericFormatter:precision}
            </td>
            <td style="\${columnWidths | columnWidths:9}" class="widget-table__numeric">
              \${v.estimatedValue | numericFormatter:precision}
            </td>
            <td if.bind="displayFifo" style="\${columnWidths | columnWidths:10}" class="widget-table__numeric">
              \${v.accountingValue | numericFormatter:precision}
            </td>
            <td if.bind="displayAvg" style="\${columnWidths | columnWidths:10}" class="widget-table__numeric">
              \${v.avgAccountingValue | numericFormatter:precision}
            </td>
            <td if.bind="displayFifo" style="\${columnWidths | columnWidths:11}" class="widget-table__numeric">
              \${v.unrealizedAccountingValue | numericFormatter:precision}
            </td>
            <td if.bind="displayAvg" style="\${columnWidths | columnWidths:11}" class="widget-table__numeric">
              \${v.avgUnrealizedAccountingValue | numericFormatter:precision}
            </td>
            <promise-resolver resolve.bind="lastItemRendered" if.bind="\$last"></promise-resolver>
          </tr>
        </template>
      </tbody>
    </table>

    <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;